class Tm {
    constructor(apiService = null) {
        this.obj_name = 'tm';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // API 方法
    //診療 | 101取得診療列表
    async getTreatmentByKeywordWithPage(parameter = null) {
        return this.callApi('get', 'getTreatmentByKeywordWithPage', parameter);
    }
    //診療 | 102取得診療詳細資料
    async getTreatmentByTreatmentId(parameter = null) {
        return this.callApi('get', 'getTreatmentByTreatmentId', parameter);
    }
    //診療 | 103新增診療
    async addTreatment(parameter, progressEvent = null) {
        return this.callApi('post', 'addTreatment', parameter, progressEvent);
    }
    //診療 | 104更新診療
    async updTreatment(parameter, progressEvent = null) {
        return this.callApi('post', 'updTreatment', parameter, progressEvent);
    }
    //診療 | 105取得處置列表
    async getTreatmentManagementByTreatmentId(parameter = null) {
        return this.callApi('get', 'getTreatmentManagementByTreatmentId', parameter);
    }
    //診療 | 106取得處置備注
    async getTreatmentManagementNoteByTreatmentId(parameter = null) {
        return this.callApi('get', 'getTreatmentManagementNoteByTreatmentId', parameter);
    }
    //診療 | 107新增處置
    async addTreatmentManagement(parameter, progressEvent = null) {
        return this.callApi('post', 'addTreatmentManagement', parameter, progressEvent);
    }
    //診療 | 108新增處置備注
    async addOrUpdTreatmentManagementNote(parameter, progressEvent = null) {
        return this.callApi('post', 'addOrUpdTreatmentManagementNote', parameter, progressEvent);
    }
    //診療 | 109取得待診療列表
    async getDashTreatmentByKeywordWithPage(parameter = null) {
        return this.callApi('get', 'getDashTreatmentByKeywordWithPage', parameter);
    }
    //診療 | 110取得待處置列表
    async getTreatmentMRecordByKeywordWithPage(parameter = null) {
        return this.callApi('get', 'getTreatmentMRecordByKeywordWithPage', parameter);
    }

    /**
     * 取得診療暫存用的 localStorage Key
     * @param {string|number} medical_record_id
     * @returns {string}
     */
    getBackupKey(medical_record_id) {
        return `tm_treatment_backup_${medical_record_id}`;
    }

    /**
     * 儲存診療暫存資料到 localStorage
     * @param {string|number} medical_record_id
     * @param {object} data
     */
    saveTempData(medical_record_id, data) {
        if (!medical_record_id || !data) return;
        try {
            const key = this.getBackupKey(medical_record_id);
            localStorage.setItem(key, JSON.stringify({
                timestamp: new Date().getTime(),
                data
            }));
            console.log(`[Tm] Data backed up for medical_record_id: ${medical_record_id}`);
        } catch (e) {
            console.error('[Tm] Failed to save temp data:', e);
        }
    }

    /**
     * 從 localStorage 取得診療暫存資料
     * @param {string|number} medical_record_id
     * @returns {object|null}
     */
    getTempData(medical_record_id) {
        if (!medical_record_id) return null;
        try {
            const key = this.getBackupKey(medical_record_id);
            const jsonStr = localStorage.getItem(key);
            if (!jsonStr) return null;
            const backup = JSON.parse(jsonStr);
            console.log(`[Tm] Found backup data for medical_record_id: ${medical_record_id}`, backup);
            return backup.data;
        } catch (e) {
            console.error('[Tm] Failed to get temp data:', e);
            return null;
        }
    }

    /**
     * 清除 localStorage 中的診療暫存資料
     * @param {string|number} medical_record_id
     */
    removeTempData(medical_record_id) {
        if (!medical_record_id) return;
        try {
            const key = this.getBackupKey(medical_record_id);
            localStorage.removeItem(key);
            console.log(`[Tm] Backup data removed for medical_record_id: ${medical_record_id}`);
        } catch (e) {
            console.error('[Tm] Failed to remove temp data:', e);
        }
    }

}

export default Tm;
